import React, { Children } from 'react';
import dayjs from 'dayjs';
import {
  IResourceComponentsProps,
  useList,
  useNavigation,
  useShow,
} from '@pankod/refine-core';
import {
  Button,
  CreateButton,
  DataGrid,
  GridColumns,
  Link,
  List,
} from '@pankod/refine-mui';
import { IGetUserPoints, IGetUsers } from 'interfaces';

export const UserPointList: React.FC<
  IResourceComponentsProps
> = () => {
  const { push } = useNavigation();
  const { showId, queryResult } = useShow<IGetUsers>();
  const { data: response } = useList<IGetUserPoints>({
    resource: 'points',
    dataProviderName: 'livenow',
    config: {
      filters: [
        {
          field: 'uid',
          operator: 'eq',
          value: showId,
        },
      ],
    },
  });

  const columns = React.useMemo<GridColumns<IGetUserPoints>>(
    () => [
      {
        field: 'type',
        headerName: 'Type',
        flex: 1,
        minWidth: 100,
        disableReorder: true,
        sortable: true,
      },
      {
        field: 'points',
        headerName: 'Points',
        flex: 1,
        minWidth: 100,
        disableReorder: true,
        sortable: true,
      },
      {
        field: 'reason_type',
        headerName: 'Reason',
        flex: 1,
        minWidth: 100,
        disableReorder: true,
        sortable: true,
      },
      {
        field: 'created_at',
        headerName: 'Created at',
        flex: 1,
        minWidth: 100,
        disableReorder: true,
        sortable: true,
        renderCell: function render({ row }) {
          return (
            <>
              {dayjs(row.created_at.toDate()).format(
                'YYYY-MM-DD HH:mm:ss'
              )}
            </>
          );
        },
      },
    ],
    []
  );

  return (
    <List
      title={`User Points (Email: ${queryResult.data?.data?.email || 'Loading...'
        })`}
      canCreate={false}
      resource="points"
      cardProps={{
        sx: { paddingX: { xs: 0, md: 0 }, position: 'relative' },
      }}
    >
      <Button
        variant="contained"
        LinkComponent={Link}
        resource="points"
        onClick={() => push(`/points/create?uid=${showId}`)}
        sx={{ position: 'absolute', right: '15px', top: '70px' }}
      >
        Add points
      </Button>

      <DataGrid
        rows={response?.data || []}
        columns={columns}
        autoHeight
        disableColumnFilter={true}
        disableColumnSelector={true}
        rowsPerPageOptions={[5, 10, 15, 20]}
        density="comfortable"
        sx={{
          '& .MuiDataGrid-cell:hover': {
            cursor: 'pointer',
          },
        }}
      />
    </List>
  );
};
